import React, { useState } from "react";
import { QualityCheckAction, ScanActionApiResponseNew } from "../scanners/types";
import { BagCard } from "@/components/ScannerActions/BagCard";
import { ORDER_BAG_STATUS, ORDER_TYPE, OrderBag, OrderProduct, PAYMENT_STATUS, REPAIR_STATUS } from "@/types";
import { ProductCard } from "@/components/ScannerActions/ProductCard";

const orderBag = {
  id: "123",
  sequence: 1,
  status: ORDER_BAG_STATUS.NONE,
};
const orderProduct = {
  id: 456,
  sequence: 4,
  name: "Gordel 2 connector",
};

const order = {
  id: "dd80b9ea-6318-4699-939d-34848f4cd2ab",
  friendlyId: "20253698136",
  urgent: false,
  paymentStatus: PAYMENT_STATUS.PAID,
  paymentMethod: null,
  proforma: false,
  internal: true,
  brand: "my-brand",
  type: ORDER_TYPE.CAR,
  guarantee: false,
  comment: "",
  internalComment: "",
  products: [],
  status: REPAIR_STATUS.UNPACKING,
  startUnpackingAt: "",
  endUnpackingAt: "",
  startBookingAt: "",
  endBookingAt: "",
  createdAt: "",
  updatedAt: "",
  winfaktSalesId: null,
  dash: null,
  dashAdvancePayment: null,
};

const reponseStates: ScanActionApiResponseNew[] = [
  {
    code: "ORDER_NOT_FOUND",
    isValid: false,
    action: QualityCheckAction.BAG_PRODUCTS,
  },
  {
    code: "ORDER_BAG_NOT_FOUND",
    isValid: false,
    action: QualityCheckAction.BAG_PRODUCTS,
    order,
  },
  {
    code: "ORDER_PRODUCT_NOT_FOUND",
    isValid: false,
    orderBag,
    action: QualityCheckAction.BAG_PRODUCTS,
    order,
  },
  {
    code: "BAGS_DO_NOT_MATCH",
    isValid: false,
    orderBag,
    orderProduct,
    action: QualityCheckAction.BAG_PRODUCTS,
    order,
  },
  {
    code: "BIN_DATASTRING",
    isValid: true,
    order,
    orderBag,
    orderProduct,
    qualityCheckProgress: 0.25,
    action: QualityCheckAction.BAG_PRODUCTS,
  },
  {
    code: "BAG_AND_PRODUCT_MATCH",
    isValid: true,
    order,
    orderBag,
    orderProduct,
    qualityCheckProgress: 0.25,
    action: QualityCheckAction.BAG_PRODUCTS,
  },
];

export const KwcBagsTest: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  // const testData = selectedIndex !== null ? reponseStates[selectedIndex] : null;
  const [orderBag, _setOrderBag] = useState<Partial<OrderBag> | null>(null);
  const [orderProduct, _setOrderProduct] = useState<Partial<OrderProduct> | null>(null);
  const [qualityCheckResponse, _setQualityCheckResponse] = useState<ScanActionApiResponseNew | null>(null);

  const handleTestDataChange = (value: string) => {
    if (value === "") {
      setSelectedIndex(null);
      _setOrderBag(null);
      _setOrderProduct(null);
      _setQualityCheckResponse(null);
    } else {
      const index = Number(value);
      setSelectedIndex(index);
      const newTestData = reponseStates[index];
      _setOrderBag(newTestData?.orderBag || null);
      _setOrderProduct(newTestData?.orderProduct || null);
      _setQualityCheckResponse(newTestData);
    }
  };

  return (
    <>
      <div style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc' }}>
        <label htmlFor="test-selector">Test Data: </label>
        <select
          id="test-selector"
          value={selectedIndex ?? ""}
          onChange={(e) => handleTestDataChange(e.target.value)}
        >
          <option value="">-- None (Reset) --</option>
          {reponseStates.map((state, index) => (
            <option key={index} value={index}>
              {state.code} ({state.isValid ? 'Valid' : 'Invalid'})
            </option>
          ))}
        </select>
      </div>

      <BagCard data={qualityCheckResponse} orderBag={orderBag} showScanMessage={true} />
      <ProductCard data={qualityCheckResponse} orderProduct={orderProduct} />
    </>
  );
};

export default KwcBagsTest;
